export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <div className={"reveal " + className} style={{ animationDelay: `${delay}s` }}>
      {children}
    </div>
  );
}

export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="block overflow-hidden pb-[0.06em]">
      <span className={"maskline " + className} style={{ animationDelay: `${delay}s` }}>
        {children}
      </span>
    </span>
  );
}
